import { render, staticRenderFns } from "./RoleSwitcher.vue?vue&type=template&id=1433994a&scoped=true&"
import script from "./RoleSwitcher.vue?vue&type=script&lang=js&"
export * from "./RoleSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./RoleSwitcher.vue?vue&type=style&index=0&id=1433994a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1433994a",
  null
  
)

export default component.exports